import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { map, switchMap, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { geralConstants } from '../constants/geral.constants';
import { CodigoAcessoComponent } from '../controls/codigo-acesso/codigo-acesso.component';
import { ContasUsuarioComponent } from '../controls/contas-usuario/contas-usuario.component';
import { AlertService } from '../shared/alert.service';
import { CommonService } from '../shared/common.service';
import { ComponentBase } from '../shared/component-base';
import { DispositivoConfiavelService } from '../shared/dispositivo-confiavel.service';
import { EncryptService } from '../shared/encrypt.service';
import { SessionService } from '../shared/session.service';
import { StorageService } from '../shared/storage.service';
import { CredorEntity } from './entities/credor.entity';
import { GrupoCredorEntity } from './entities/grupo-credor.entity';
import { UsuarioEntity } from './entities/usuario.entity';
import { LoginAlterarSenhaComponent } from './login-alterar-senha/login-alterar-senha.component';
import { LoginRecuperarSenhaComponent } from './login-recuperar-senha/login-recuperar-senha.component';
import { ConfiarDispositivoResponse, LoginService, ReenviarMfaResponse, ValidarMfaResponse } from './login.service';
import { WhitelabelEntity } from './entities/whitelabel.entity';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent extends ComponentBase implements OnInit {
  identificacaoUsuario: string;
  senhaAcesso: string;
  ip: string;
  showSenha: boolean;
  codigoUsuario: number;
  atualizarEmail: boolean;
  atualizarCelular: boolean;
  email: string;
  celular: string;
  codigoCelular: string;
  codigoEmail: string;
  hashValidacaoContato: string;
  hashMfa: string;
  codigoMfa: string;
  mfaPendente = false;
  codigoMfaInvalido = false;
  reenviandoCodigo = false;
  segundosParaReenviar = 0;
  /** Prazo do "confiar neste dispositivo" para este login. 0 não pergunta. */
  diasDispositivoConfiavel = 0;
  /** Código aceito; falta a resposta do popup de confiar no dispositivo. */
  perguntarDispositivo = false;
  confiandoDispositivo = false;
  private continuarAposMfa: () => void;
  private contadorReenvio: any;

  /** Tamanho do código do MFA. Espelha GerarCodigoMfa no backend. */
  static readonly TAMANHO_CODIGO_MFA = 6;

  /** Mesmo intervalo que o backend aplica em SegundosEntreReenviosMfa. */
  private static readonly SEGUNDOS_REENVIO_MFA = 60;

  readonly tamanhoCodigoMfa = LoginComponent.TAMANHO_CODIGO_MFA;

  /** Código de validação de contato. Mesmo tamanho do MFA — ver TamanhoCodigoValidacaoContato. */
  readonly tamanhoCodigoContato = 6;

  codigoCelularInvalido = false;
  codigoEmailInvalido = false;

  /**
   * Canais comprovados no MFA desta tentativa de acesso.
   *
   * Ficam fora de `usuario` de propósito: aquela entidade é recarregada depois do MFA, com os
   * dados lidos antes dele, e levaria junto os indicadores desatualizados.
   */
  private mfaValidouEmail = false;
  private mfaValidouCelular = false;

  @ViewChild(CodigoAcessoComponent) campoCodigo: CodigoAcessoComponent;

  /** A tela de primeiro acesso pode ter dois campos ao mesmo tempo: celular e e-mail. */
  @ViewChildren(CodigoAcessoComponent) camposCodigoContato: QueryList<CodigoAcessoComponent>;
  validacaoDados: boolean;
  alterarSenha: boolean;
  usuario: UsuarioEntity = new UsuarioEntity();
  urlInvalida = true;
  hash: string;
  grupoCredores: GrupoCredorEntity[] = [];
  credores: CredorEntity[] = [];
  grupoSelecionado: GrupoCredorEntity;
  codigoGrupo: number;
  codigoCredor: number;
  nomeCredor: string;
  cnpjCredor: string;
  modal: NgbModalRef;
  urlCallBack: string;
  primeiroAcesso: boolean;
  userEncrypt: string;
  passEncrypt: string;
  codigoSistema: number;
  showGrupoCredor: boolean;
  contasUsuario: any[];
  contasUsuarioCredor: any[];
  /** Acessos do login que a restrição de IP deixou de fora. */
  acessosBarradosIp: any[] = [];
  ignoraGrupoCredor: boolean;
  loadingWhitelabel = false;

  usuarioHibrido: boolean;
  usuarioBackoffice: boolean;
  backoffice: boolean;
  whitelabel: WhitelabelEntity;

  @ViewChild('frmLogin', { static: true }) frmLogin: NgForm;
  @ViewChild(ContasUsuarioComponent, { static: true })
  contasUsuarioComponentRef: ContasUsuarioComponent;
  @ViewChild(LoginRecuperarSenhaComponent, { static: true })
  loginRecuperarSenhaComponentRef: LoginRecuperarSenhaComponent;
  @ViewChild('modalGrupoCredor', { static: true }) modalGrupoCredor: ElementRef;
  @ViewChild('loginAlterarSenha', { static: true })
  loginAlterarSenhaRef: LoginAlterarSenhaComponent;

  constructor(
    private loginService: LoginService,
    protected session: SessionService,
    private commonService: CommonService,
    protected router: Router,
    protected alert: AlertService,
    protected storage: StorageService,
    protected ngbModal: NgbModal,
    private encripyService: EncryptService,
    private activatedRoute: ActivatedRoute,
    private dispositivoConfiavel: DispositivoConfiavelService,
  ) {
    super();

    this.session.clear();
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.storage.data?.acessoNegado) {
      this.alert.warning(this.storage.data.acessoNegado);
      this.storage.data = null;
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.urlCallBack = this.commonService.isValidUrl(urlParams.get('urlcallback')) ? urlParams.get('urlcallback') : atob(urlParams.get('urlcallback'));

    this.consultarWhitelabel();

    const dominio = this.commonService.extrairDominio(this.urlCallBack);
    this.ignoraGrupoCredor = geralConstants.sitesSemSelecaoCredor.findIndex((x) => x.url.indexOf(dominio) > -1) > -1;

    this.alterarSenha = this.router.url.indexOf('/alterarsenha') >= 0;
    if (!this.alterarSenha) {
      if (!this.urlCallBack) {
        window.location.href = environment.appFeev;
        return;
      }

      this.urlInvalida = false;
      this.commonService
        .obterIp()
        .pipe(take(1))
        .subscribe((response: any) => (this.ip = response.ip));
    } else {
      this.urlInvalida = false;
    }
  }

  acessar(): void {
    this.markAsTouched(this.frmLogin);

    if (!this.frmLogin.valid) {
      return;
    }

    this.autenticarIdentificacaoSenha();
  }

  onkeyUp(event: any): void {
    if (event.keyCode === 13) this.acessar();
  }

  contaUsuarioSelecionada(usuario: UsuarioEntity): void {
    this.session.usuario = usuario;
    this.router.navigate(['home']);
  }

  processarUsuarioAutenticado(contasUsuario: UsuarioEntity[]): void {
    this.session.contasUsuario = contasUsuario;

    if (this.session.contasUsuario.length > 1) {
      // Abre o modal com as contas do usuário para que possa ser selecionada a conta a logar
      const primeiroUsuarioCredor = this.session.contasUsuario.find(
        (x) => x.codigoCredor > 0
      );
      if (primeiroUsuarioCredor === null)
        this.session.usuario = this.session.contasUsuario[0];
      else this.session.usuario = primeiroUsuarioCredor;

      this.contasUsuarioComponentRef.abrirContas();
    } else this.contaUsuarioSelecionada(this.session.contasUsuario[0]);
  }

  validarIdentificacaoSenha(): void {
    this.markAsTouched(this.frmLogin);

    if (this.frmLogin.valid) {
      this.loading(() =>
        this.loginService.consultarCodigoUsuarioEmailCpfCelular(
          this.identificacaoUsuario
        )
      )
        .pipe(take(1))
        .subscribe((response: any) => {
          this.usuario = new UsuarioEntity({
            codigoUsuario: response.codigoUsuario,
            usuario: this.identificacaoUsuario,
            senha: this.senhaAcesso,
            codigoCredor: response.codigoCredor,
            ip: this.ip,
            ipsLiberados: response.ipsLiberados,
            validaIpCredor: response.validaIpCredor,
            validaIpUsuario: response.validaIpUsuario,
            celular: response.celular,
            email: response.email,
            celularValidado: response.celularValidado,
            emailValidado: response.emailValidado,
          });

          this.loading(() =>
            this.loginService.consultarCodigoUsuarioSemSenha(
              this.identificacaoUsuario
            )
          )
            .pipe(take(1))
            .subscribe((codigoUsuario: number) => {
              if (codigoUsuario > 0) {
                this.alert
                  .warning(
                    'Antes de prosseguir é necessário atualizar a sua senha.'
                  )
                  .then(() => {
                    window.location.href =
                      'alterarsenha?primeiroacesso=true&usuario=' +
                      encodeURIComponent(
                        this.encripyService.encryptData(
                          this.identificacaoUsuario
                        )
                      );
                  });
              } else {
                this.codigoUsuario = response.codigoUsuario;
                this.showSenha = true;
              }
            });
        });
    }
  }

  continuarLogin(auth: any): void {
    if (auth && auth?.user && auth?.pass && auth?.urlCallback) {
      this.alterarSenha = false;

      this.identificacaoUsuario = this.encripyService.decryptData(auth.user);
      this.senhaAcesso = this.encripyService.decryptData(auth.pass);
      this.urlCallBack = auth.urlCallback;

      this.codigoSistema = this.commonService.obterCodigoSistema(this.urlCallBack);

      this.autenticarIdentificacaoSenha();
      return;
    }
  }

  /** Contas barradas pelo IP vêm no fim da resposta e sem hash: servem só para o aviso. */
  private separarAcessosBarrados(contas: any[]): any[] {
    const lista = contas ?? [];
    this.acessosBarradosIp = lista.filter(x => x.bloqueadoPorIp);
    return lista.filter(x => !x.bloqueadoPorIp);
  }

  filtrarContasUsuarioLogin(array: any[]): void {
    this.contasUsuario = array.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.codigoGrupoCredor === item.codigoGrupoCredor
      ))
    );
  }

  autenticarIdentificacaoSenha(): void {
    this.usuario.usuario = this.identificacaoUsuario;
    this.usuario.senha = this.senhaAcesso;
    this.usuario.codigoSistema = this.codigoSistema;

    this.call(() =>
      this.loginService.consultarCodigoUsuarioSemSenha(
        this.identificacaoUsuario
      )
    )
      .pipe(take(1))
      .subscribe((codigoUsuario: number) => {
        if (codigoUsuario > 0) {
          // Primeiro acesso passa pelo e-mail, como a recuperação de senha. Antes o app mandava
          // direto para a tela de troca com a identificação cifrada na URL — e como aquela chave
          // é pública, qualquer pessoa definia a senha de qualquer conta que nunca tivesse logado.
          this.call(() =>
            this.loginService.recuperarSenha(
              this.identificacaoUsuario,
              this.urlCallBack ? btoa(this.urlCallBack) : null,
              true
            )
          )
            .pipe(take(1))
            .subscribe(() => {
              this.alert.info(
                'Para definir a sua senha, abra o link que enviamos para o seu e-mail cadastrado. Ele vale por 10 minutos.'
              );
            });
        } else {
          // Uma assinatura só. O forkJoin que havia aqui assinava `consultaUsuario$` — que é frio —
          // duas vezes, e disparava dois GETs iguais de identificação. Com o captcha obrigatório
          // isso passou a custar dois desafios, e as duas retentativas reusavam o mesmo token do
          // checkbox: token de v2 é de uso único, o Google recusa o segundo com
          // `timeout-or-duplicate` e o login falhava mesmo depois de o usuário resolver o desafio.
          this.call(() =>
            this.loginService.consultarCodigoUsuarioEmailCpfCelular(
              this.identificacaoUsuario
            )
          ).pipe(
            take(1),
            switchMap((responseUsuario: any) => {
              this.usuario = new UsuarioEntity({
                codigoUsuario: responseUsuario.codigoUsuario,
                usuario: this.identificacaoUsuario,
                senha: this.senhaAcesso,
                codigoCredor: responseUsuario.codigoCredor,
                ip: this.ip,
                ipsLiberados: responseUsuario.ipsLiberados,
                validaIpCredor: responseUsuario.validaIpCredor,
                validaIpUsuario: responseUsuario.validaIpUsuario,
                celular: responseUsuario.celular,
                email: responseUsuario.email,
                celularValidado: responseUsuario.celularValidado,
                emailValidado: responseUsuario.emailValidado,
                codigoSistema: this.codigoSistema,
              });
              return this.loading(() =>
                this.loginService.autenticarIdentificacaoSenha(this.usuario)
              ).pipe(
                take(1),
                map((responseHash: any[]) => [responseUsuario, responseHash] as [any, any[]])
              );
            })
          ).subscribe(
            ([responseUsuario, responseHash]: [any, any[]]) => {
              responseHash = this.separarAcessosBarrados(responseHash);
              const continuar = () => {

                this.contasUsuarioCredor = responseHash;

                if (responseHash?.length > 1) {
                  this.filtrarContasUsuarioLogin(responseHash);
                }
                else
                  this.contasUsuario = responseHash;

                this.showGrupoCredor = this.contasUsuario?.length === 1;

                if (this.contasUsuario?.length === 1) {
                  this.hash = this.contasUsuario[0].hash;
                  this.usuario = responseUsuario;

                  const usuario = this.contasUsuario.find(x => x.hash === this.hash);
                  this.backoffice = usuario.backOffice;

                  const dominio = this.commonService.extrairDominio(this.urlCallBack);
                  if (geralConstants.sitesSemSelecaoCredor.findIndex((x) => x.url.indexOf(dominio) > -1) > -1) {

                    if (this.contasUsuario[0]?.backOffice) {
                      const token = btoa(
                        this.encripyService.encryptData(
                          `0|0|BackOffice|true`
                        )
                      );

                      const s = this.urlCallBack.indexOf('?') > -1 ? '&' : '?';
                      window.location.href = `${this.urlCallBack}${s}hash=${this.hash}&token=${token}`;
                    }
                    else {
                      this.loading(() => this.loginService.consultarGrupoCredorUsuario(this.hash))
                        .pipe(take(1))
                        .subscribe((response: GrupoCredorEntity[]) => {
                          this.grupoCredores = response;

                          if (this.grupoCredores.length === 1 && this.grupoCredores[0].credores.length > 0) {
                            this.ignoraGrupoCredor = false;
                            this.showGrupoCredor = true;
                            this.carregarCredores(this.grupoCredores[0].codigoGrupoCredor);
                          }
                          else {
                            this.codigoGrupo = this.grupoCredores[0]?.codigoGrupoCredor;
                            this.codigoCredor = this.grupoCredores[0]?.credores[0]?.codigoCredor;
                            this.nomeCredor = this.grupoCredores[0]?.credores[0]?.nomeCredor;
                            this.cnpjCredor = this.grupoCredores[0]?.credores[0]?.cnpjCredor;

                            const token = btoa(
                              this.encripyService.encryptData(
                                `${this.codigoGrupo ?? 0}|${this.codigoCredor ?? 0}|${this.nomeCredor ?? 'BackOffice'}|${this.backoffice}|${this.cnpjCredor}`
                              )
                            );

                            const s = this.urlCallBack.indexOf('?') > -1 ? '&' : '?';
                            window.location.href = `${this.urlCallBack}${s}hash=${this.hash}&token=${token}`;
                          }
                        });
                    }
                  }
                  this.tratarUsuarioAutenticado();
                } else if (this.contasUsuario?.length === 0) {
                  this.alert.warning('Não foi possível autenticar o usuário.');
                }
                else {
                  this.showGrupoCredor = false;
                  this.tratarUsuarioAutenticado();
                }
              };
              this.iniciarMfa(responseHash, continuar);
            }
          );
        }
      });
  }

  showInfo() {
    this.alert.info('Foram encontradas mais de uma conta de usuário para o e-mail/celular informado. Selecione uma conta para continuar.');
  }

  iniciarMfa(contas: any[], continuar: () => void): void {
    const hashMfa = contas?.[0]?.hashMfa;
    this.diasDispositivoConfiavel = contas?.[0]?.diasDispositivoConfiavel ?? 0;
    // Sem hashMfa o backend dispensou o código: dispositivo confiável ou Mfa:Habilitado = false
    // (só em homologação). Se o envio do código falha, ele devolve erro antes.
    if (!hashMfa) {
      continuar();
      return;
    }

    // Pediu o código mesmo com token guardado: o token venceu ou foi revogado.
    this.dispositivoConfiavel.remover(this.identificacaoUsuario);
    this.perguntarDispositivo = false;

    this.hashMfa = hashMfa;
    this.codigoMfa = '';
    this.codigoMfaInvalido = false;
    this.mfaValidouEmail = false;
    this.mfaValidouCelular = false;
    this.validacaoDados = false;
    this.continuarAposMfa = continuar;
    this.mfaPendente = true;

    // O código acabou de sair. O backend recusa um reenvio antes do intervalo, então a tela já
    // abre contando — botão habilitado que responde "aguarde" é pior que botão desabilitado.
    this.iniciarContagemReenvio(LoginComponent.SEGUNDOS_REENVIO_MFA);
    setTimeout(() => this.campoCodigo?.focar());
  }

  /** Disparado pelo campo quando a última caixa é preenchida. Valida sem exigir clique. */
  codigoMfaInformado(codigo: string): void {
    this.codigoMfa = codigo;
    this.validarMfa();
  }

  validarMfa(): void {
    const codigo = this.codigoMfa?.trim().toUpperCase();
    if (!codigo || codigo.length !== LoginComponent.TAMANHO_CODIGO_MFA) {
      this.codigoMfaInvalido = true;
      this.alert.warning('Informe o código de seis caracteres enviado por SMS ou e-mail.');
      return;
    }

    this.codigoMfaInvalido = false;

    this.loading(() => this.loginService.validarMfa(this.hashMfa, codigo))
      .pipe(take(1))
      .subscribe((resposta: ValidarMfaResponse) => {
        this.mfaValidouEmail = !!resposta?.emailValidado;
        this.mfaValidouCelular = !!resposta?.celularValidado;
        this.pararContagemReenvio();

        // O cartão do código fica atrás do popup até a resposta; o hash é o que autoriza confiar.
        if (this.diasDispositivoConfiavel > 0) {
          this.perguntarDispositivo = true;
          return;
        }

        this.concluirMfa();
      }, () => {
        // A mensagem do backend já sai pelo interceptor. Aqui é só deixar a tela pronta para a
        // próxima tentativa, com o campo limpo e o foco no começo.
        this.codigoMfaInvalido = true;
        this.codigoMfa = '';
        this.campoCodigo?.limpar();
      });
  }

  /** Falha ao confiar não barra o login: só pede o código de novo da próxima vez. */
  confiarNoDispositivo(): void {
    this.confiandoDispositivo = true;
    this.loginService.confiarDispositivo(this.hashMfa)
      .pipe(take(1))
      .subscribe((resposta: ConfiarDispositivoResponse) => {
        if (resposta?.tokenDispositivo)
          this.dispositivoConfiavel.guardar(this.identificacaoUsuario, resposta.tokenDispositivo);
        this.concluirMfa();
      }, () => this.concluirMfa());
  }

  concluirMfa(): void {
    this.perguntarDispositivo = false;
    this.confiandoDispositivo = false;
    this.mfaPendente = false;
    this.hashMfa = null;
    this.codigoMfa = null;
    const continuar = this.continuarAposMfa;
    this.continuarAposMfa = null;
    continuar?.();
  }

  reenviarCodigoMfa(): void {
    if (this.segundosParaReenviar > 0 || this.reenviandoCodigo || !this.hashMfa) {
      return;
    }

    this.reenviandoCodigo = true;

    this.loginService.reenviarMfa(this.hashMfa)
      .pipe(take(1))
      .subscribe((resposta: ReenviarMfaResponse) => {
        this.reenviandoCodigo = false;

        // O hash muda a cada reenvio. Guardar o novo é o que mantém a validação funcionando.
        this.hashMfa = resposta?.hashMfa || this.hashMfa;
        this.codigoMfa = '';
        this.codigoMfaInvalido = false;
        this.campoCodigo?.limpar();

        this.iniciarContagemReenvio(resposta?.segundosParaNovoReenvio || LoginComponent.SEGUNDOS_REENVIO_MFA);
        this.alert.info('Enviamos um código novo. O anterior deixou de valer.');
      }, () => {
        this.reenviandoCodigo = false;
        // Recusa do backend costuma ser intervalo ou limite. Segura o botão para não insistir.
        this.iniciarContagemReenvio(LoginComponent.SEGUNDOS_REENVIO_MFA);
      });
  }

  private iniciarContagemReenvio(segundos: number): void {
    this.pararContagemReenvio();
    this.segundosParaReenviar = segundos;

    this.contadorReenvio = setInterval(() => {
      this.segundosParaReenviar--;
      if (this.segundosParaReenviar <= 0) {
        this.pararContagemReenvio();
      }
    }, 1000);
  }

  private pararContagemReenvio(): void {
    if (this.contadorReenvio) {
      clearInterval(this.contadorReenvio);
      this.contadorReenvio = null;
    }

    this.segundosParaReenviar = 0;
  }

  ngOnDestroy(): void {
    this.pararContagemReenvio();
    super.ngOnDestroy();
  }

  tratarUsuarioAutenticado() {
    if (this.usuario.codigoUsuario) {
      const faltaEmail = !this.usuario.emailValidado && !this.mfaValidouEmail;
      const faltaCelular = !this.usuario.celularValidado && !this.mfaValidouCelular;

      if (faltaEmail || faltaCelular) {
        this.email = faltaEmail ? ' ' : '';
        this.celular = faltaCelular ? ' ' : '';
        this.codigoEmail = '';
        this.codigoCelular = '';
        this.codigoEmailInvalido = false;
        this.codigoCelularInvalido = false;
        this.validacaoDados = true;
        this.reenviarCodigo(faltaEmail && faltaCelular ? 'todos' : (faltaEmail ? 'email' : 'celular'));
        return;
      }
    }

    if (this.contasUsuario.length === 1) {
      this.hash = this.contasUsuario[0].hash;
      this.consultarGrupoCredor();
    } else {
      this.abriModalGrupoCredor();
    }

  }

  selecionarContaUsuario(): void {
    // Consultar na lista de contas para verificar se o usuario é backoffice
    const usuario = this.contasUsuario.find(x => x.hash === this.hash);
    this.backoffice = usuario.backOffice;

    // chama a rotina de consultar grupo de credores
    this.consultarGrupoCredor(false);

    // Se o usuario for backoffice, exibe a lista de credores
    const dominio = this.commonService.extrairDominio(this.urlCallBack);
    const siteSemSelecaoCredor = geralConstants.sitesSemSelecaoCredor.findIndex((x) => x.url.indexOf(dominio) > -1) > -1;

    // Se o usuario for backoffice e o site nao permitir selecao de credor, ignora o grupo de credores
    this.ignoraGrupoCredor = usuario.descricao.toLowerCase().indexOf('backoffice') > -1 && siteSemSelecaoCredor;
    this.showGrupoCredor = !this.ignoraGrupoCredor;

    if (!this.ignoraGrupoCredor)
      this.consultarGrupoCredor(false);
  }

  consultarGrupoCredor(abrirModal = true) {
    this.loading(() => this.loginService.consultarGrupoCredorUsuario(this.hash))
      .pipe(take(1))
      .subscribe((response: GrupoCredorEntity[]) => {
        this.grupoCredores = response;

        if (this.ignoraGrupoCredor) {
          this.showGrupoCredor = false;
        } else {
          if (response.length === 1) {
            this.carregarCredores(response[0].codigoGrupoCredor);
          }

          if (response.length > 0 && response.find((grupo) => grupo.credores.length >= 1) && abrirModal) {
            this.abriModalGrupoCredor();
          }

          if (response.length > 0 && response.find((grupo) => grupo.credores.length >= 1) && !abrirModal) {
            this.showGrupoCredor = true;
          }
        }
      });
  }

  autenticarGoogle(): void {
    this.loading(() => this.loginService.autenticarGoogle())
      .pipe(take(1))
      .subscribe(
        (result: any) => {
          setTimeout(() => {
            this.loading(() =>
              this.loginService.autenticarUsuarioFirebase(
                result.user.uid,
                result.user.email,
                this.codigoSistema
              )
            )
              .pipe(take(1))
              .subscribe((responseHash: any) => {
                responseHash = this.separarAcessosBarrados(responseHash);
                const continuar = () => {
                  this.contasUsuarioCredor = responseHash;

                  if (responseHash?.length > 1) {
                    this.filtrarContasUsuarioLogin(responseHash);
                  }
                  else
                    this.contasUsuario = responseHash;

                  this.showGrupoCredor = this.contasUsuario?.length === 1;

                  if (this.contasUsuario?.length === 1) {
                    this.hash = this.contasUsuario[0].hash;

                    const usuario = this.contasUsuario.find(x => x.hash === this.hash);
                    this.backoffice = usuario.backOffice;

                    const dominio = this.commonService.extrairDominio(this.urlCallBack);
                    if (geralConstants.sitesSemSelecaoCredor.findIndex((x) => x.url.indexOf(dominio) > -1) > -1) {

                      if (this.contasUsuario[0]?.backOffice) {
                        const token = btoa(
                          this.encripyService.encryptData(
                            `0|0|BackOffice|true`
                          )
                        );

                        const s = this.urlCallBack.indexOf('?') > -1 ? '&' : '?';
                        window.location.href = `${this.urlCallBack}${s}hash=${this.hash}&token=${token}`;
                      }
                      else {
                        this.loading(() => this.loginService.consultarGrupoCredorUsuario(this.hash))
                          .pipe(take(1))
                          .subscribe((response: GrupoCredorEntity[]) => {
                            this.grupoCredores = response;

                            if (this.grupoCredores.length === 1 && this.grupoCredores[0].credores.length > 0) {
                              this.ignoraGrupoCredor = false;
                              this.showGrupoCredor = true;
                              this.carregarCredores(this.grupoCredores[0].codigoGrupoCredor);
                            }
                            else {
                              this.codigoGrupo = this.grupoCredores[0]?.codigoGrupoCredor;
                              this.codigoCredor = this.grupoCredores[0]?.credores[0]?.codigoCredor;
                              this.nomeCredor = this.grupoCredores[0]?.credores[0]?.nomeCredor;
                              this.cnpjCredor = this.grupoCredores[0]?.credores[0]?.cnpjCredor;

                              const token = btoa(
                                this.encripyService.encryptData(
                                  `${this.codigoGrupo ?? 0}|${this.codigoCredor ?? 0}|${this.nomeCredor ?? 'BackOffice'}|${this.backoffice}|${this.cnpjCredor}`
                                )
                              );

                              const s = this.urlCallBack.indexOf('?') > -1 ? '&' : '?';
                              window.location.href = `${this.urlCallBack}${s}hash=${this.hash}&token=${token}`;
                            }
                          });
                      }
                    }
                    this.tratarUsuarioAutenticado();
                  } else if (responseHash?.length === 0) {
                    this.alert.warning('Não foi possível autenticar o usuário.');
                  }
                  else {
                    this.showGrupoCredor = false;
                    this.tratarUsuarioAutenticado();
                  }
                };
                this.iniciarMfa(responseHash, continuar);
              });
          }, 0);
        },
        (error) => {
          if (error.code === 'auth/user-disabled')
            this.alert.warning('Esta conta foi desativada pelo administrador.');
        }
      );
  }

  recuperarSenha(primeiroAcesso: boolean): void {
    this.primeiroAcesso = primeiroAcesso;

    this.loginRecuperarSenhaComponentRef.abrirModaRecuperarSenha();
  }

  voltar() {
    window.location.reload();
  }

  get iconeValidacaoContato(): string {
    if (this.celular && this.email)
      return 'fa-user-shield';

    return this.celular ? 'fa-mobile-alt' : 'fa-envelope';
  }

  get textoValidacaoContato(): string {
    const tamanho = this.tamanhoCodigoContato;

    if (this.celular && this.email)
      return `Enviamos um código de ${tamanho} caracteres para o seu celular e outro para o seu e-mail. Informe os dois para continuar.`;

    if (this.celular)
      return `Enviamos um código de ${tamanho} caracteres para o seu celular cadastrado.`;

    return `Enviamos um código de ${tamanho} caracteres para o seu e-mail cadastrado.`;
  }

  private get tipoReenvioContato(): string {
    if (this.celular && this.email)
      return 'todos';

    return this.celular ? 'celular' : 'email';
  }

  codigoContatoInformado(): void {
    const faltaCelular = !!this.celular && (this.codigoCelular?.length || 0) < this.tamanhoCodigoContato;
    const faltaEmail = !!this.email && (this.codigoEmail?.length || 0) < this.tamanhoCodigoContato;

    if (faltaCelular || faltaEmail)
      return;

    this.validarCodigoEmailCelular();
  }

  validarCodigoEmailCelular() {
    if (!this.hashValidacaoContato) {
      this.alert.warning('Não foi possível validar o código. Peça um novo.');
      return;
    }

    this.codigoCelularInvalido = false;
    this.codigoEmailInvalido = false;

    this.loading(() =>
      this.loginService.validarContato(
        this.hashValidacaoContato,
        this.email ? this.codigoEmail : null,
        this.celular ? this.codigoCelular : null)
    )
      .pipe(take(1))
      .subscribe(() => {
        this.pararContagemReenvio();
        this.atualizarCelular = false;
        this.atualizarEmail = false;
        this.usuario.emailValidado = true;
        this.usuario.celularValidado = true;

        this.validacaoDados = false;
        this.email = '';
        this.celular = '';

        this.tratarUsuarioAutenticado();
      }, () => {
        this.codigoCelularInvalido = !!this.celular;
        this.codigoEmailInvalido = !!this.email;
        this.codigoCelular = '';
        this.codigoEmail = '';
        this.camposCodigoContato?.forEach(campo => campo.limpar());
      });
  }

  reenviarCodigoContato(): void {
    if (this.segundosParaReenviar > 0 || this.reenviandoCodigo)
      return;

    this.codigoCelular = '';
    this.codigoEmail = '';
    this.codigoCelularInvalido = false;
    this.codigoEmailInvalido = false;
    this.camposCodigoContato?.forEach(campo => campo.limpar());

    this.reenviarCodigo(this.tipoReenvioContato);
  }

  reenviarCodigo(tipo: string) {
    tipo = tipo ? tipo : 'todos';
    this.reenviandoCodigo = true;

    this.loading(() =>
      this.loginService.enviarTokensValidacao(this.usuario, tipo)
    )
      .pipe(take(1))
      .subscribe((resp: any) => {
        this.reenviandoCodigo = false;
        this.hashValidacaoContato = resp?.hashValidacao;
        this.validacaoDados = true;

        this.iniciarContagemReenvio(LoginComponent.SEGUNDOS_REENVIO_MFA);
      }, () => {
        this.reenviandoCodigo = false;
        this.iniciarContagemReenvio(LoginComponent.SEGUNDOS_REENVIO_MFA);
      });
  }

  getNomeBotao(): string {
    if (!this.codigoUsuario) return 'Próximo';

    if (this.atualizarCelular && this.atualizarEmail) return 'Atualizar Dados';

    if (this.atualizarCelular && !this.atualizarEmail)
      return 'Atualizar Celular';

    if (!this.atualizarCelular && this.atualizarEmail)
      return 'Atualizar E-mail';

    return 'Acessar o sistema';
  }

  abriModalGrupoCredor(): void {
    this.modal = this.openModal(this.modalGrupoCredor);
  }

  carregarCredores(grupoCredor: number): void {
    this.grupoSelecionado = this.grupoCredores.find(
      (x) => x.codigoGrupoCredor === grupoCredor
    );
    this.codigoGrupo = this.grupoSelecionado.codigoGrupoCredor;

    this.credores = this.grupoSelecionado.credores;
    if (this.credores.length === 1) {
      this.codigoCredor = this.grupoSelecionado.credores[0].codigoCredor;
      this.nomeCredor = this.grupoSelecionado.credores[0].nomeCredor;
      this.cnpjCredor = this.grupoSelecionado.credores[0].cnpjCredor;

      if (this.grupoCredores.length === 1) this.selecionarConta();
    } else this.codigoCredor = null;
  }

  selecionarCredor(codigoCredor: number): void {
    const credor = this.grupoSelecionado.credores.find(
      (x) => x.codigoCredor === codigoCredor
    );

    if (!credor) {
      this.alert.warning('Credor não encontrado.');
      return;
    }

    this.codigoCredor = credor.codigoCredor;
    this.nomeCredor = credor.nomeCredor;
    this.cnpjCredor = credor.cnpjCredor;
  }

  selecionarConta(): void {
    if (this.modal) {
      this.modal.close();
    }

    const s = this.urlCallBack.indexOf('?') > -1 ? '&' : '?';

    if (!this.ignoraGrupoCredor) {
      if (!this.codigoGrupo) {
        this.alert.warning(
          'Selecione um grupo para prossessguir com o acesso ao sistema.'
        );
        return;
      }

      if (!this.codigoCredor) {
        this.alert.warning(
          'Selecione um credor para prossessguir com o acesso ao sistema.'
        );
        return;
      }
    }
    else {
      this.codigoGrupo = 0;
      this.codigoCredor = 0;
      this.nomeCredor = 'BackOffice';
    }

    const executarRedirect = () => {
      const nomeCredor =
        this.backoffice && this.nomeCredor !== 'BackOffice'
          ? `BackOffice (${this.nomeCredor})`
          : this.nomeCredor;

      const hash = this.contasUsuarioCredor.find(
        (x) => x.codigoCredor == (this.backoffice ? 0 : this.codigoCredor)
      ).hash;

      const token = btoa(
        this.encripyService.encryptData(
          `${this.codigoGrupo}|${this.codigoCredor}|${nomeCredor}|${this.backoffice}|${this.cnpjCredor}`
        )
      );

      window.location.href = `${this.urlCallBack}${s}hash=${hash}&token=${token}`;
    };

    if (this.ignoraGrupoCredor) {
      executarRedirect();
      return;
    }
    this.consultarSituacaoCredor(this.codigoCredor, executarRedirect);
  }

  consultarWhitelabel() {
    const urlCallback = new URL(this.urlCallBack);
    const hostnameCallback = urlCallback.host;
    this.loadingWhitelabel = true;

    this.loading(() =>
      this.loginService.consultarWhiteLabel(hostnameCallback, window.location.host), true
    )
      .pipe(take(1))
      .subscribe((resp: any) => {
        if (resp) {
          this.session.whitelabel = resp;
        }
        const codigoSistema = this.commonService.obterCodigoSistema(this.urlCallBack);
        this.codigoSistema = codigoSistema ? +codigoSistema : 0;
        this.session.codigoSistema = this.codigoSistema;
        this.registrarCSS();
        this.loadingWhitelabel = false;
      });
  }

  registrarCSS() {
    if (this.session.whitelabel) {
      window.CSS.registerProperty({
        name: "--login-gradient-1",
        syntax: "<color>",
        inherits: false,
        initialValue: this.session.whitelabel.corPrimaria,
      });
      window.CSS.registerProperty({
        name: "--login-gradient-2",
        syntax: "<color>",
        inherits: false,
        initialValue: this.session.whitelabel.corPrimaria,
      });
      window.CSS.registerProperty({
        name: "--primary",
        syntax: "<color>",
        inherits: false,
        initialValue: this.session.whitelabel.corPrimaria,
      });
    } else {
      if (this.codigoSistema == 2) {
        window.CSS.registerProperty({
          name: "--login-gradient-1",
          syntax: "<color>",
          inherits: false,
          initialValue: "#370B60",
        });
        window.CSS.registerProperty({
          name: "--login-gradient-2",
          syntax: "<color>",
          inherits: false,
          initialValue: "#602498",
        });
        window.CSS.registerProperty({
          name: "--primary",
          syntax: "<color>",
          inherits: false,
          initialValue: "#602498",
        });
      }
      else if (this.codigoSistema == 7) {
        if (this.session.whitelabel) {
          window.CSS.registerProperty({
            name: "--login-gradient-1",
            syntax: "<color>",
            inherits: false,
            initialValue: this.session.whitelabel.corPrimaria,
          });
          window.CSS.registerProperty({
            name: "--login-gradient-2",
            syntax: "<color>",
            inherits: false,
            initialValue: this.session.whitelabel.corPrimaria,
          });
          window.CSS.registerProperty({
            name: "--primary",
            syntax: "<color>",
            inherits: false,
            initialValue: this.session.whitelabel.corPrimaria,
          });
        } else {
          window.CSS.registerProperty({
            name: "--login-gradient-1",
            syntax: "<color>",
            inherits: false,
            initialValue: "#8e248e",
          });
          window.CSS.registerProperty({
            name: "--login-gradient-2",
            syntax: "<color>",
            inherits: false,
            initialValue: "#8e248e",
          });
          window.CSS.registerProperty({
            name: "--primary",
            syntax: "<color>",
            inherits: false,
            initialValue: "#8e248e",
          });
        }
      }
      else {
        window.CSS.registerProperty({
          name: "--login-gradient-1",
          syntax: "<color>",
          inherits: false,
          initialValue: "#1F2A36",
        });
        window.CSS.registerProperty({
          name: "--login-gradient-2",
          syntax: "<color>",
          inherits: false,
          initialValue: "#00826A",
        });
      }
    }
    this.session.applyWhitelabelCssVars();
  }

  getYear(): number {
    const d = new Date();
    return d.getFullYear();
  }

  getPlataforma(): string {
    if (this.codigoSistema === 2) {
      return "Entrar na Minha Conta";
    }
    if (this.codigoSistema === 5 || this.codigoSistema === 6) {
      return "Autenticação";
    }
    return "Entrar na plataforma";
  }

  autoSignIn() {
    this.activatedRoute.params
      .pipe(take(1))
      .subscribe(params => {

        const chaveSeguranca = params['chaveSeguranca'];
        const hash = params['hash'];
        const usuario = params['usuario'];
        const codigoApp = params['codigoApp'];
        const cnpj = params['cnpj'];

        this.loading(() => this.loginService.autoSignInApp(chaveSeguranca, hash, codigoApp, usuario, cnpj))
          .pipe(take(1))
          .subscribe((usuario: any) => {

            const contasUsuario: UsuarioEntity[] = [];

            contasUsuario.push(new UsuarioEntity({
              codigoUsuario: usuario.codigoUsuario,
              usuario: this.identificacaoUsuario,
              senha: usuario.hash,
              codigoCredor: usuario.codigoCredor === 0 ? null : usuario.codigoCredor,
              nomeCredor: usuario.nomeCredor,
              grupoCredores: usuario.grupoCredores,
              tempoSessao: usuario.tempoSessao,
              administrador: usuario.administrador,
              ip: this.ip,
              hasHash: true,
              nomePessoa: usuario.nomePessoa,
              recursos: usuario.recursos,
              usuarioDiscador: usuario.usuarioDiscador,
              ipsLiberados: usuario.ipsLiberados,
              validaIpCredor: usuario.validaIpCredor,
              validaIpUsuario: usuario.validaIpUsuario,
              cobrador: usuario.cobrador,
            }));

            this.processarUsuarioAutenticado(contasUsuario);
          });
      });
  }

  consultarSituacaoCredor(codigoCredor: number, onCredorAtivo?: () => void): void {
    if (this.codigoSistema !== 7) {
      if (onCredorAtivo) {
        onCredorAtivo();
      }
      return;
    }

    if (!codigoCredor) {
      if (onCredorAtivo) {
        onCredorAtivo();
      }
      return;
    }

    this.loading(() => this.loginService.consultarSituacaoCredor(codigoCredor))
      .pipe(take(1))
      .subscribe((resp: any) => {

        const codigoSituacaoCredor = resp.codigoSituacaoCredor

        if (!resp) {
          if (onCredorAtivo) {
            onCredorAtivo();
          }
          return;
        }

        if (codigoSituacaoCredor == 'N') {
          this.alert
            .warning('Sua conta está Em Análise. Qualquer dúvida entre em contato com nosso time comercial pelo telefone ' + environment.telefoneComercial)
            .then(() => {
              window.location.href = environment.minhacontaUrl;
            });
          return;
        }

        if (codigoSituacaoCredor != 'A' && codigoSituacaoCredor != 'S') {
          this.alert.error(
            'O credor selecionado não está ativo. Por favor, entre em contato com o administrador do sistema.'
          );
          return;
        }

        if (onCredorAtivo) {
          onCredorAtivo();
        }
      });
  }
}
